import imageLoadingGift from '@/assets/img/loading.gif'

export default class LazyImageLoader {
  constructor(selector = '.lazy-load', onLoadCallback) {
    this.selector = selector
    this.onLoadCallback = onLoadCallback
  }

  start() {
    const intervalId = setInterval(() => {
      this.images = document.querySelectorAll(
        `${this.selector}:not(.lazy-load-inited)`
      )

      if (this.images.length > 0) {
        clearInterval(intervalId)
        this.loadingImageSrc = imageLoadingGift
        this.observer = new IntersectionObserver(
          this._handleIntersection.bind(this)
        )

        this._initObserver()
      }
    }, 500)

    this._autoDestroy(intervalId)
  }

  _autoDestroy(intervalId) {
    const THREE_MIN = 180000

    setTimeout(() => {
      if (this.images.length === 0) {
        clearInterval(intervalId)
        console.warn('Lazy loading automatic cancellation')
      }
    }, THREE_MIN)
  }

  _initObserver() {
    this.images.forEach((image) => {
      const loadingImage = new Image()
      loadingImage.src = this.loadingImageSrc
      loadingImage.classList.add('lazy-load-loading')

      image.classList.add('lazy-load-inited')
      image.parentNode.insertBefore(loadingImage, image)

      this.observer.observe(image)
    })
  }

  _handleIntersection(entries) {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        const image = entry.target
        const loadingImage = image.previousSibling

        loadingImage.style.display = 'block'

        const src = image.getAttribute('data-src')

        if (src) {
          const realImage = new Image()

          realImage.onload = () => {
            loadingImage.style.display = 'none'
            image.classList.remove('lazy-load')
            image.src = src

            if (typeof this.onLoadCallback === 'function') {
              this.onLoadCallback(image)
            }

            this.observer.unobserve(image)
          }

          realImage.src = src
        }
      }
    })
  }
}
